module.exports = __webpack_public_path__ + "media/images/purchase-step-4-d3005c5336daa317d6d1ab7abe188e06.png";